"use client";

import { useLocale } from "./LocaleProvider";

export default function LegalNotice() {
  if (useLocale() !== "ro") return null;

  return (
    <div className="container-px mx-auto max-w-3xl pt-6">
      <p
        lang="ro"
        className="rounded-xl border border-[#27E8A7]/40 bg-black/80 px-4 py-3 text-sm text-white/85"
      >
        Acest document juridic este disponibil doar în limba engleză. Pentru lămuriri, vă rugăm să
        contactați clinica.
      </p>
    </div>
  );
}
